'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { RovingFocusItem } from '../../utilities/RovingFocus/RovingFocusItem.js';
import { Button } from '../Button/Button.js';
import { useToggleGroupItem } from './useToggleGroupitem.js';

/**
 * A single item in a ToggleGroup.
 * @example
 * <ToggleGroup.Item value='1'>Toggle 1</ToggleGroup.Item>
 */
const ToggleGroupItem = forwardRef(function ToggleGroupItem(rest, ref) {
    const { active, buttonProps, value } = useToggleGroupItem(rest);
    return (jsx(RovingFocusItem, { asChild: true, value: value, children: jsx(Button, { variant: active ? 'primary' : 'tertiary', ref: ref, ...rest, ...buttonProps }) }));
});

export { ToggleGroupItem };
